module.exports = {
    "breadcrumbs": `Struktura nawigacyjna`
};


//# sourceMappingURL=pl-PL.main.js.map
